import WebHttpClient from '~src/httpClient/WebHttpClient';
import {
  GetSiteEncryptionKeyRequest,
  IGetSiteEncryptionKeyResult
} from '~src/kmsInOnline/serverApi/GetSiteEncryptionKeyRequest';

export function retrieveSiteEncryptionKey(): Promise<IGetSiteEncryptionKeyResult>  {
  return WebHttpClient.sendRequest(new GetSiteEncryptionKeyRequest({}));
}

export const RetrieveSiteEncryptionKeyService = {
  retrieveSiteEncryptionKey: retrieveSiteEncryptionKey
};